import React from "react";
import logo from "../../assets/images/logo/logo-pipe.png";
import "../../assets/css/layout/footer.css";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaTwitter,
  FaInstagram,
  FaPinterestP,
  FaWhatsapp,
} from "react-icons/fa";

export default function Footer({ onMenuClick }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="rcc-footer">
      <div className="container footer-main-grid">
        {/* Column 1: About Company */}
        <div className="footer-column">
          <h4 className="footer-column-heading">RCC CONCRETE'S</h4>

          <p className="footer-company-desc">
            Premier manufacturer of premium RCC Hume Pipes compliant with IS 458
            structural guidelines. Casting high-density concrete blocks for
            heavy infrastructure.
          </p>

          <div className="footer-contact-info">
            <div className="contact-item">
              <span className="contact-icon contact-location-icon">
                <FaMapMarkerAlt />
              </span>

              <span>
                pattom palace, 71, Road, Gowreesapattom, Pattom,
                Mangalore, Karnataka 695004  
              </span>
            </div>

            <div className="contact-item">
              <span className="contact-icon contact-location-icon">
                <FaPhoneAlt />
              </span>

              <span>+91 96005 44451</span>
            </div>

            <div className="contact-item">
              <span className="contact-icon contact-location-icon">
                <FaEnvelope />
              </span>

              <span>info@mangalorerccpipes.in</span>
            </div>
          </div>
        </div>

        {/* Column 2: Our Services */}
        <div className="footer-column">
          <h4 className="footer-column-heading">OUR SERVICES</h4>

          <ul className="footer-links-list">
            <li>
              <button onClick={() => onMenuClick("services")}>
                Centrifugal Pipe Casting
              </button>
            </li>

            <li>
              <button onClick={() => onMenuClick("services")}>
                Vertical Vibration Casting
              </button>
            </li>

            <li>
              <button onClick={() => onMenuClick("services")}>
                Custom Reinforcement Cages
              </button>
            </li>

            <li>
              <button onClick={() => onMenuClick("services")}>
                Hydraulic Pressure Testing
              </button>
            </li>

            <li>
              <button onClick={() => onMenuClick("services")}>
                On-Site Logistics Support
              </button>
            </li>
          </ul>
        </div>

        {/* Column 3: Customer Support */}
        <div className="footer-column">
          <h4 className="footer-column-heading">CUSTOMER SUPPORT</h4>

          <ul className="footer-links-list">
            <li>
              <button onClick={() => alert("FAQ Coming Soon")}>FAQ</button>
            </li>

            <li>
              <button onClick={() => alert("Knowledge Base Loading")}>
                Technical Specifications
              </button>
            </li>

            <li>
              <button onClick={() => onMenuClick("contact")}>
                Online Procurement Assistance
              </button>
            </li>

            <li>
              <button onClick={() => alert("Privacy Policy")}>
                Privacy Policy
              </button>
            </li>

            <li>
              <button onClick={() => alert("Terms & Conditions")}>
                Terms & Condition
              </button>
            </li>
          </ul>
        </div>

        {/* Column 4: Useful Links */}
        <div className="footer-column">
          <h4 className="footer-column-heading">USEFUL LINKS</h4>

          <ul className="footer-links-list">
            <li>
              <button onClick={() => alert("Terms applied")}>Our Terms</button>
            </li>

            <li>
              <button onClick={() => onMenuClick("about")}>
                Company Story
              </button>
            </li>

            <li>
              <button onClick={() => alert("Legal Disclaimer")}>
                Legal Terms
              </button>
            </li>

            <li>
              <button onClick={() => alert("Partner network")}>
                Industrial Partners
              </button>
            </li>

            <li>
              <button onClick={() => alert("Latest Updates")}>
                Recent News
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Floating Curvature Brand Board */}
      <div className="container">
        <div className="footer-brand-capsule">
          <div className="capsule-top-row">
            <div className="capsule-logo" onClick={() => onMenuClick("hero")}>
              <img
                src={logo}
                alt="Solid Pipes Logo"
                className="capsule-logo-img"
              />
            </div>

            <nav className="capsule-nav">
              <button onClick={() => onMenuClick("about")}>About Us</button>

              <button onClick={() => onMenuClick("products")}>Pricing</button>

              <button onClick={() => onMenuClick("products")}>Reviews</button>

              <button onClick={() => alert("Blog opening soon")}>Blog</button>

              <button onClick={() => alert("Community channel")}>
                Community
              </button>
            </nav>
          </div>

          <div className="capsule-divider"></div>

          <div className="capsule-bottom-row">
            <p className="capsule-copyright">
              Copyright {currentYear} Pigeon. Designed By{" "}
              <a
                href="https://frontlinetechnologies.org/"
                rel="noreferrer"
                target="_blank"
              >
                Frontline Technologies
              </a>
              . All Rights Reserved
            </p>

            <div className="capsule-socials">
              <a
                href="#facebook"
                aria-label="Facebook"
                className="social-facebook"
              >
                <FaGlobe />
              </a>

              <a
                href="#twitter"
                aria-label="Twitter"
                className="social-twitter"
              >
                <FaTwitter />
              </a>

              <a
                href="#instagram"
                aria-label="Instagram"
                className="social-instagram"
              >
                <FaInstagram />
              </a>

              <a
                href="#pinterest"
                aria-label="Pinterest"
                className="social-pinterest"
              >
                <FaPinterestP />
              </a>

              <a
                href="#whatsapp"
                aria-label="WhatsApp"
                className="social-whatsapp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
